import React, {
    forwardRef,
    MouseEvent,
    Suspense,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import { Styles } from "react-modal";
import { useDispatch } from "react-redux";
import SideDropdown from "components/SideDrop/SideDropdown";
import {
    CustomLightTrashIcon,
    CustomPlusIcon,
    DropTabDiv,
    List,
    NameSpan,
    Search,
    PinCheckbox,
    TabItemRow,
    StarWrapper,
} from "components/SideDrop/TabsSideDropdown/tabsDropStyles";
import { IPage, setActivePage } from "store/reducers/QuotesPageReducer";
import { useClickOutside } from "hooks/useClickOutside";
import { useAppSelector } from "../../../hooks/redux";
import { removeTab, togglePinTab } from "store/reducers/TabsSlice";
import { IProps } from "../TabsLayoutDropdown/TabsLayoutDropdown";
import CreateTabModal from "../../CreateTabModal/CreateTabModal";
import Cookies from "js-cookie";
import { setActivePageId } from "store/reducers/quotes";
import { StarFilled, StarOutlined } from "@ant-design/icons";

const AreYouSureModal = React.lazy(
    () => import("components/AreYouSureModal/AreYouSureModal"),
);

const customStyle: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "350px",
        height: "210px",
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};

const TabsSideDropdown = forwardRef<HTMLDivElement, IProps>(
    ({ isOpen, wrapperRef, closeHandler }, ref) => {
        const dispatch = useDispatch();
        const { selectedRobotId } = useAppSelector((state) => state.robots);
        const { pages, activePage } = useAppSelector(
            (state) => state.quotesPage,
        );
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [searchName, setSearchName] = useState("");
        const [deletingTabId, setDeletingTabId] = useState(0);
        const [deletingTabName, setDeletingTabName] = useState("");
        const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] =
            useState(false);

        const trashRef = useRef(null);
        const localRef = useRef<HTMLDivElement>(null);
        useImperativeHandle(ref, () => localRef.current!);
        useClickOutside(isOpen, localRef, closeHandler);
        useClickOutside(isOpen, wrapperRef, closeHandler);
        const MAX_PINNED_TABS = 3;
        const closeModal = () => {
            setIsModalOpen(false);
        };

        const openModal = () => {
            setIsModalOpen(true);
        };

        const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
            setSearchName(e.currentTarget.value.toLowerCase());
        };

        const handleDeleteSureModalOpen = (id: number, name: string) => {
            setDeletingTabId(id);
            setDeletingTabName(name);
            setIsAreYouSureModalOpen(true);
        };

        const handleTabDeleteClick = () => {
            dispatch(removeTab(deletingTabId));
            setIsAreYouSureModalOpen(false);
            dispatch(setActivePage(null));
        };
        const pinnedCount =
            pages?.filter((item: IPage) => item?.is_pinned)?.length ?? 0;

        const setPage = (e: MouseEvent, id: number) => {
            const target = e.target as Element;
            if (id === activePage?.id || target.id === "trash_icon") return;
            const cookieKey = `activePageId_${selectedRobotId}`;
            Cookies.set(cookieKey, id.toString(), { expires: 30 });
            console.log(
                "назначили на новую страницу",
                cookieKey,
                id.toString(),
            );

            dispatch(setActivePageId(id.toString()));
            dispatch(setActivePage(id));
            closeHandler();
        };
        const handlePinToggle = (id: number, currentPinned: boolean) => {
            dispatch(togglePinTab({ id, is_pinned: !currentPinned }));
        };
        const plusIcon = <CustomPlusIcon onClick={openModal} />;
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <div>
                    {isAreYouSureModalOpen && (
                        <AreYouSureModal
                            title={`Удалить вкладку ${deletingTabName}? Все настройки вкладки удалятся безвозвратно`}
                            isOpen={isAreYouSureModalOpen}
                            onRequestClose={() =>
                                setIsAreYouSureModalOpen(false)
                            }
                            onApplyClick={handleTabDeleteClick}
                        />
                    )}
                    <SideDropdown dropTitle={"Вкладки"} plusIcon={plusIcon}>
                        <>
                            <Search
                                onChange={handleSearchChange}
                                placeholder={"Поиск"}
                            />
                            {selectedRobotId ? (
                                <List>
                                    {pages
                                        ?.filter((item: IPage) =>
                                            item?.name
                                                ?.toLowerCase()
                                                .includes(searchName),
                                        )
                                        ?.sort((a, b) => b.id - a.id)
                                        .map((item: IPage) => {
                                            const isCheckboxDisabled =
                                                !item.is_pinned &&
                                                pinnedCount >= MAX_PINNED_TABS;

                                            return (
                                                <DropTabDiv
                                                    key={`dd_tab_${item.id}`}
                                                >
                                                    <NameSpan
                                                        onClick={(e) =>
                                                            setPage(e, item.id)
                                                        }
                                                        key={item.id}
                                                    >
                                                        {item.name}
                                                    </NameSpan>
                                                    <StarWrapper
                                                        disabled={
                                                            isCheckboxDisabled
                                                        }
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (
                                                                isCheckboxDisabled
                                                            )
                                                                return;
                                                            handlePinToggle(
                                                                item.id,
                                                                !!item.is_pinned,
                                                            );
                                                        }}
                                                    >
                                                        {item.is_pinned ? (
                                                            <StarFilled
                                                                style={{
                                                                    color: "#f5b301",
                                                                }}
                                                            />
                                                        ) : (
                                                            <StarOutlined
                                                                style={{
                                                                    color: isCheckboxDisabled
                                                                        ? "#d9d9d9"
                                                                        : "#999",
                                                                }}
                                                            />
                                                        )}
                                                    </StarWrapper>
                                                    <CustomLightTrashIcon
                                                        ref={trashRef}
                                                        id="trash_icon"
                                                        onClick={() =>
                                                            handleDeleteSureModalOpen(
                                                                item.id,
                                                                item.name,
                                                            )
                                                        }
                                                    />
                                                </DropTabDiv>
                                            );
                                        })}
                                </List>
                            ) : (
                                <div>загрузка..</div>
                            )}
                        </>
                    </SideDropdown>
                </div>
                <CreateTabModal
                    isModalOpen={isModalOpen}
                    closeModal={closeModal}
                    customStyle={customStyle}
                />
            </Suspense>
        );
    },
);

export default TabsSideDropdown;
